import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "product-image--wrapper"
}
const _hoisted_2 = { class: "product-image--container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_file_drop = _resolveComponent("file-drop")!
  const _component_editable_toggle_block = _resolveComponent("editable-toggle-block")!

  return (_openBlock(), _createBlock(_component_editable_toggle_block, {
    readonly: _ctx.readonly,
    "model-value": _ctx.catalogue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:catalogue', $event))),
    "switch-prop": "print_slip",
    title: "Packing slip"
  }, {
    default: _withCtx(({ editState }) => [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "description q-mb-md" }, "Personalize packing slips for this channel by uploading the company’s logo.", -1)),
      (_ctx.images[_ctx.catalogue?.sys?.id]?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(), _createBlock(_component_q_img, {
                class: "image",
                key: `product-image_${_ctx.selectedImage}`,
                src: `${_ctx.images[_ctx.catalogue?.sys.id][_ctx.selectedImage]}`,
                fit: "contain"
              }, null, 8, ["src"]))
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.readonly)
        ? (_openBlock(), _createBlock(_component_file_drop, {
            key: 1,
            onChange: _ctx.fileHandler,
            accepts: ['.jpg', '.png', '.svg'],
            "is-image": "",
            label: "Drop a file or choose one"
          }, null, 8, ["onChange"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["readonly", "model-value"]))
}